(function () {
  const DESKTOP_QUERY = '(min-width: 768px)';
  const CLOSE_DURATION = 400;

  function initFooterAccordion(root) {
    const items = root.querySelectorAll('.custom-footer__accordion-item');
    if (!items.length) return;

    const mediaQuery = window.matchMedia(DESKTOP_QUERY);

    function syncAccordionState() {
      items.forEach(function (item) {
        item.classList.remove('is-closing');

        if (mediaQuery.matches) {
          item.setAttribute('open', '');
          item.dataset.accordionDisabled = 'true';
          return;
        }

        delete item.dataset.accordionDisabled;
        item.removeAttribute('open');
      });
    }

    items.forEach(function (item) {
      const summary = item.querySelector('summary');
      const panel = item.querySelector('.custom-footer__accordion-panel');

      item.addEventListener('toggle', function () {
        if (item.dataset.accordionDisabled === 'true') {
          item.setAttribute('open', '');
        }
      });

      if (!summary || !panel) return;

      summary.addEventListener('click', function (event) {
        if (item.dataset.accordionDisabled === 'true') {
          event.preventDefault();
          return;
        }

        if (!item.open || item.classList.contains('is-closing')) return;

        event.preventDefault();
        item.classList.add('is-closing');

        let closeFinished = false;

        function finishClose(transitionEvent) {
          if (closeFinished) return;

          if (
            transitionEvent &&
            (transitionEvent.target !== panel ||
              transitionEvent.propertyName !== 'grid-template-rows')
          ) {
            return;
          }

          closeFinished = true;
          panel.removeEventListener('transitionend', finishClose);
          item.classList.remove('is-closing');
          item.removeAttribute('open');
        }

        panel.addEventListener('transitionend', finishClose);
        window.setTimeout(finishClose, CLOSE_DURATION);
      });
    });

    syncAccordionState();

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', syncAccordionState);
      return;
    }

    mediaQuery.addListener(syncAccordionState);
  }

  function boot() {
    document.querySelectorAll('.custom-footer').forEach(initFooterAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
    return;
  }

  boot();
})();
